import { Icon } from '@iconify/react'
import arrowLeftFill from '@iconify/icons-eva/arrow-left-fill'
import arrowRightFill from '@iconify/icons-eva/arrow-right-fill'
import roundKeyboardArrowLeft from '@iconify/icons-ic/round-keyboard-arrow-left'
import roundKeyboardArrowRight from '@iconify/icons-ic/round-keyboard-arrow-right'
// material
import { useTheme, styled } from '@mui/material/styles'
import { Box, BoxProps } from '@mui/material'
import MIconButton from './@material-extend/MIconButton'

// ----------------------------------------------------------------------

const ICON_SIZE = {
  width: 20,
  height: 20
}

const RootStyle = styled(Box)(({ theme }) => ({
  zIndex: 9,
  display: 'flex',
  position: 'absolute',
  top: theme.spacing(2),
  right: theme.spacing(2)
}))

const ArrowStyle = styled(MIconButton)(({ theme }) => ({
  padding: 6,
  opacity: 0.48,
  color: theme.palette.common.white,
  '&:hover': { opacity: 1 }
}))

// ----------------------------------------------------------------------

interface CarouselControlsArrowsBasic1Props extends BoxProps {
  arrowLine?: boolean;
  onNext?: VoidFunction;
  onPrevious?: VoidFunction;
}

export default function CarouselControlsArrowsBasic1({
  arrowLine,
  onNext,
  onPrevious,
  ...other
}: CarouselControlsArrowsBasic1Props) {
  const theme = useTheme()
  const isRTL = theme.direction === 'rtl'

  return (
    <RootStyle {...other}>
      <ArrowStyle size="small" onClick={onPrevious}>
        {arrowLine ? (
          <Icon icon={isRTL ? roundKeyboardArrowRight : roundKeyboardArrowLeft} {...ICON_SIZE} />
        ) : (
          <Icon icon={isRTL ? arrowRightFill : arrowLeftFill} {...ICON_SIZE} />
        )}
      </ArrowStyle>

      <ArrowStyle size="small" onClick={onNext}>
        {arrowLine ? (
          <Icon icon={isRTL ? roundKeyboardArrowLeft : roundKeyboardArrowRight} {...ICON_SIZE} />
        ) : (
          <Icon icon={isRTL ? arrowLeftFill : arrowRightFill} {...ICON_SIZE} />
        )}
      </ArrowStyle>
    </RootStyle>
  )
}
